import { useQuery } from '@tanstack/react-query';
import { BaseQueryOpts } from './baseTypes';
import { getAllCptCodes, getCptCodesByIds } from '@uplift/api';

import * as batshit from '@yornaath/batshit';


const cptCodeByIdBatch = batshit.create({
  fetcher: async (cptCodeIds: string[]) => {
    const response = await getCptCodesByIds(cptCodeIds.filter(Boolean));

    return response.data;
  },
  resolver: batshit.keyResolver('id'),
  scheduler: batshit.windowScheduler(10)
});


export const useCptCodeByIdQuery = (cptCodeId: string, opts?: BaseQueryOpts) => {
  return useQuery({
    queryKey: [ 'cpt-code', cptCodeId ],
    queryFn: async () => {
      try {
        return cptCodeByIdBatch.fetch(cptCodeId);
      } catch (error) {
        console.error(error);
        return null;
      }
    },
    ...opts,
  });
};


export const useCptCodesByIdsQuery = (cptCodeIds?: string[], opts?: BaseQueryOpts) => {
  return useQuery({
    queryKey: [ 'cpt-codes', cptCodeIds ],
    queryFn: async () => {
      try {
        if (!cptCodeIds?.length) {
          return [];
        }

        const cptCodes = await getCptCodesByIds(cptCodeIds);

        return cptCodes.data;
      } catch (error) {
        console.error(error);
        return null;
      }
    },
    ...opts,
  });
};

export const useAllCptCodes = (opts?: BaseQueryOpts) => {
  return useQuery({
    queryKey: [ 'all-cpt-codes' ],
    queryFn: async () => {
      try {
        const allCptCodes = await getAllCptCodes();

        return allCptCodes.data;
      } catch (error) {
        console.error(error);
        return null;
      }
    },
    ...opts,
  });
};
